import { render, staticRenderFns } from "./ConferenceArchive.vue?vue&type=template&id=47bd99c4"
import script from "./ConferenceArchive.vue?vue&type=script&lang=js"
export * from "./ConferenceArchive.vue?vue&type=script&lang=js"
import style0 from "./ConferenceArchive.vue?vue&type=style&index=0&id=47bd99c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports